module.exports = __webpack_public_path__ + "img/presion_baro_hover.933eb945.png";